export default {
  setReports(state, reports) {
    state.reports = reports;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
